import { useQueryWithUserId, useRegionStore } from '@northladder/services';

import { USER_ACCOUNTS_API } from '../userAccountsAPIClient';

/**
 * This is to track Notification history data or cached RQ data.
 */
export const FETCH_TENANT_COUNTRY_LIST_QUERY =
  'fetch-tenant-country-list-query-key';

/**
 * This performs a get request and retrieves the list of countries for a tenant.
 */
export const useTenantCountryListQuery = (tenantId: string) => {
  const { tenantConfig } = useRegionStore();
  const { data, error, isError, isFetching, isPending, refetch } =
    useQueryWithUserId({
      queryKey: [FETCH_TENANT_COUNTRY_LIST_QUERY, tenantId],
      retry: false,
      queryFn: () => USER_ACCOUNTS_API.fetchTenantCountryList(tenantId),
      staleTime: 1000 * 60 * 5, // 5 minutes
      enabled: !!tenantConfig,
    });

  return {
    data,
    error,
    isError,
    isFetching,
    isPending: tenantConfig ? isPending : false,
    refetch,
  };
};
